import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import './DemoDashboard.css';

const demos = [
    {
        id: 'test',
        name: 'Classic Elegance',
        description: 'Timeless design with a focus on readability and grace.',
        theme: 'light',
        icon: '🏛️',
        gradient: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        type: 'qr'
    },
    {
        id: 'chic',
        name: 'Modern Chic',
        description: 'Vibrant, playful, and photo-centric card layout.',
        theme: 'colorful',
        icon: '🥑',
        gradient: 'linear-gradient(135deg, #FFFEFF 0%, #D7FFFE 100%)',
        type: 'qr'
    },
    {
        id: 'luxe',
        name: 'Midnight Luxe',
        description: 'Premium dark mode for high-end dining experiences.',
        theme: 'dark',
        icon: '🥂',
        gradient: 'linear-gradient(135deg, #232526 0%, #414345 100%)',
        type: 'qr'
    },
    {
        id: 'dsc',
        name: 'DineStack Classic',
        description: 'Clean, image-focused grid layout perfect for visual menus.',
        theme: 'light',
        icon: '🍱',
        gradient: 'linear-gradient(135deg, #ffffff 0%, #f1f2f6 100%)',
        type: 'qr'
    },
    {
        id: 'explorer',
        name: 'Menu Explorer',
        description: 'Explore menus, categories and items with modals for variants and tags.',
        theme: 'light',
        icon: '🧭',
        gradient: 'linear-gradient(135deg, #ffffff 0%, #e9f7ff 100%)',
        type: 'qr'
    },
    {
        id: 'neon',
        name: 'Neon Nectar',
        description: 'Cyberpunk synthwave vibes with glowing neon accents.',
        theme: 'dark',
        icon: '🌃',
        gradient: 'linear-gradient(135deg, #050505 0%, #200122 100%)',
        type: 'qr'
    },
    {
        id: 'boho',
        name: 'Boho Bliss',
        description: 'Organic, artistic, and peaceful design with earthy tones.',
        theme: 'light',
        icon: '🎨',
        gradient: 'linear-gradient(135deg, #fffaf0 0%, #ffefd5 100%)',
        type: 'qr'
    },
    {
        id: 'comic',
        name: 'Comic Crunch',
        description: 'Bold pop-art layouts inspired by classic comic book action.',
        theme: 'light',
        icon: '💥',
        gradient: 'linear-gradient(135deg, #ffee00 0%, #ffcc00 100%)',
        type: 'qr'
    },
    {
        id: 'cosmic',
        name: 'Cosmic Cantina',
        description: 'Interstellar hierarchical explorer with space-age navigation.',
        theme: 'dark',
        icon: '🚀',
        gradient: 'linear-gradient(135deg, #02010a 0%, #3a0d6e 100%)',
        type: 'qr'
    },
    {
        id: 'classic-print',
        name: 'Classic Print',
        description: 'Elegant serif typography with decorative accents for upscale dining',
        icon: '📄',
        gradient: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
        theme: 'light',
        type: 'pdf'
    },
    {
        id: 'modern-minimalist',
        name: 'Modern Minimalist',
        description: 'Clean contemporary design with crisp borders and modern fonts',
        icon: '📋',
        gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
        theme: 'light',
        type: 'pdf'
    },
    {
        id: 'royal-gold',
        name: 'Royal Gold',
        description: 'Luxury high-end branding with gold accents and ornate borders',
        icon: '👑',
        gradient: 'linear-gradient(135deg, #000000 0%, #434343 100%)',
        theme: 'dark',
        type: 'pdf'
    },
    {
        id: 'garden-fresh',
        name: 'Garden Fresh',
        description: 'Vibrant organic layout with green tones and botanical aesthetics',
        icon: '🌿',
        gradient: 'linear-gradient(135deg, #d4fc79 0%, #96e6a1 100%)',
        theme: 'light',
        type: 'pdf'
    },
    {
        id: 'rustic-wood',
        name: 'Rustic Wood',
        description: 'Vintage wood texture with typewriter fonts and rustic charm',
        icon: '🪵',
        gradient: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)',
        theme: 'dark',
        type: 'pdf'
    },
    {
        id: 'urban-pop',
        name: 'Urban Pop',
        description: 'Bold neon colors with asymmetric design and urban attitude',
        icon: '⚡',
        gradient: 'linear-gradient(135deg, #ff0080 0%, #7928ca 100%)',
        theme: 'dark',
        type: 'pdf'
    },
    {
        id: 'goan-fiesta',
        name: 'Goan Fiesta',
        description: 'Vibrant sunset colors with palm leaf motifs and beach vibes',
        icon: '🌞',
        gradient: 'linear-gradient(135deg, #FF8C00 0%, #FF1493 100%)',
        theme: 'dark',
        type: 'pdf'
    },
    {
        id: 'azure-azulejos',
        name: 'Azure Azulejos',
        description: 'Elegant blue and white tile patterns representing heritage Goa',
        icon: '💎',
        gradient: 'linear-gradient(135deg, #003399 0%, #e6f0ff 100%)',
        theme: 'dark',
        type: 'pdf'
    },
    {
        id: 'tropical-spice',
        name: 'Tropical Spice',
        description: 'Warm crimson and forest green tones inspired by spice plantations',
        icon: '🌶️',
        gradient: 'linear-gradient(135deg, #800000 0%, #1b4d3e 100%)',
        theme: 'dark',
        type: 'pdf'
    }
];

const DemoDashboard = () => {
    const [activeFilter, setActiveFilter] = useState('qr');

    const filteredTemplates = demos.filter(demo => demo.type === activeFilter);

    return (
        <div className="dashboard-container">
            <header className="dashboard-header">
                <h1>Vyanjan Templates</h1>
                <p>Explore our premium mobile-first menu designs</p>

                {/* Toggle Switch */}
                <div className="template-toggle">
                    <button
                        className={`toggle-btn ${activeFilter === 'qr' ? 'active' : ''}`}
                        onClick={() => setActiveFilter('qr')}
                    >
                        <span className="toggle-icon">📱</span>
                        QR Templates
                    </button>
                    <button
                        className={`toggle-btn ${activeFilter === 'pdf' ? 'active' : ''}`}
                        onClick={() => setActiveFilter('pdf')}
                    >
                        <span className="toggle-icon">🖨️</span>
                        PDF Templates
                    </button>
                </div>
            </header>

            <div className="dashboard-grid">
                {filteredTemplates.map(demo => {
                    const to = `/r/${demo.id}?templateName=${encodeURIComponent(demo.name)}`;
                    return (
                        <Link key={demo.id} to={to} className="demo-card-link">
                            <div className="demo-card" style={{ background: demo.gradient }}>
                                <div className="demo-icon">{demo.icon}</div>
                                <div className="demo-content">
                                    <h2 style={{ color: demo.theme === 'dark' ? 'white' : '#333' }}>{demo.name}</h2>
                                    <p style={{ color: demo.theme === 'dark' ? '#ccc' : '#666' }}>{demo.description}</p>
                                    <span className={`demo-badge ${demo.theme}`}>
                                        {demo.type === 'pdf' ? 'View Template →' : 'View Demo →'}
                                    </span>
                                </div>
                            </div>
                        </Link>
                    );
                })}
            </div>

            <Footer />
        </div>
    );
};

export default DemoDashboard;
